<template>
  <section>
    <m-table-list
      ref="tableList"
      :fetch-list-func="fetchListFunc"
      :search-form.sync="filters"
    >
      <template v-slot:search-items>
        <m-search-panel
          @searchBoxChange="handleSearch"
          isShowOpenButton
          @keyup.enter.native="handleSearch()"
        >
          <div slot="title">
            数据筛选
            <el-input
              style="padding-left: 20px; width: 310px !important"
              maxlength="50"
              placeholder="输入问题标题/问题描述搜索"
              clearable
              size="medium"
              v-model.trim="filters.keyword"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="handleSearch"
              ></el-button>
            </el-input>
          </div>
          <div class="filters">
            <div class="query-item-all">
              <div class="filter-item">
                <div class="demonstration">工单编号</div>
                <el-input
                  v-model="filters.wkOrderId"
                  placeholder="编号"
                  oninput="value=value.replace(/[^\d]/g,'')"
                ></el-input>
              </div>
              <div class="filter-item">
                <div class="demonstration">工单状态</div>
                <el-select v-model="filters.workOrderStatus" placeholder="全部">
                  <el-option
                    v-for="(item, index) in statusOptions"
                    :key="index"
                    :value="item.code"
                    :label="item.name"
                  ></el-option>
                </el-select>
              </div>
              <div class="filter-item">
                <div class="demonstration">审批状态</div>
                <el-select v-model="filters.handleResult" placeholder="全部">
                  <el-option
                    v-for="(item, index) in handleResultOptions"
                    :key="index"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </div>
              <div class="filter-item">
                <div class="demonstration">提交时间</div>
                <div class="block">
                  <el-date-picker
                    style="z-index: 0"
                    v-model="timeQuantum"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="timestamp"
                    @change="handleTimeChange"
                    format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </div>
              </div>
              <div class="filter-item">
                <div class="demonstration">工单分类</div>
                <el-select
                  v-model="filters.parentQaTypeId"
                  placeholder="工单分类"
                  @change="workCutChange($event)"
                >
                  <el-option
                    v-for="(item, index) in workCutList"
                    :key="index"
                    :value="item.parentTypeId"
                    :label="item.parentQaTypeName"
                  ></el-option>
                </el-select>
              </div>
              <div class="filter-item">
                <div class="demonstration">工单类型</div>
                <el-select
                  :disabled="workTypeFlag"
                  v-model="filters.qaTypeId"
                  placeholder="工单类型"
                >
                  <el-option
                    v-for="(item, index) in workTypeList"
                    :key="index"
                    :value="item.qaTypeId"
                    :label="item.qaTypeName"
                  ></el-option>
                </el-select>
              </div>
              <div class="filter-item">
                <div class="demonstration">优先级</div>
                <el-select v-model="filters.priority" placeholder="优先级">
                  <el-option
                    v-for="(label, value) in priorityEnum"
                    :key="label"
                    :value="value"
                    :label="label"
                  ></el-option>
                </el-select>
              </div>
              <div class="filter-item">
                <div class="demonstration">相关机构</div>
                <el-input v-model.trim="filters.companyInfo"></el-input>
              </div>
              <div class="filter-item buttons button">
                <el-button
                  type="primary"
                  size="small"
                  class="find"
                  @click="handleSearch"
                  >查询
                </el-button>
                <el-button
                  type="primary"
                  size="small"
                  plain
                  class="reset"
                  @click="handleClearSearchForm"
                  >重置
                </el-button>
              </div>
            </div>
          </div>
        </m-search-panel>
      </template>
      <template v-slot:page-title>
        <div class="page-tabe-title">
          <div class="right">
            <span class="line"></span>
            <div>数据列表</div>
          </div>
        </div>
      </template>
      <template v-slot:table-columns>
        <el-table-column
          prop="wkOrderId"
          label="工单编号"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="问题标题"
          prop="wkOrderTopic"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="工单类型"
          prop="qaTypeName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="承接人"
          prop="acceptorName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="提交时间"
          prop="submitTime"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="审批状态"
          prop="handleResult"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.handleResult"
              size="mini"
              :type="handleResultEnum[scope.row.handleResult].type"
            >
              {{ handleResultEnum[scope.row.handleResult].label }}
            </el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="工单状态" prop="status" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag size="mini" :type="statusEnum[scope.row.status].type">
              {{ statusEnum[scope.row.status].label }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="优先级"
          prop="priority"
          :formatter="formatPriority"
        ></el-table-column>
        <el-table-column
          label="相关机构"
          prop="companyInfo"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.companyInfo || "-" }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="170px">
          <template slot-scope="{ row }">
            <span v-if="row.status == 3">
              <el-button type="text" @click="look(row.id, row.wkOrderId)"
                >查看</el-button
              >
              <!--              <el-button-->
              <!--                  type="text"-->
              <!--                  @click.native="-->
              <!--                  $router.push({-->
              <!--                    name: 'work.submit.write',-->
              <!--                    query: {-->
              <!--                      qaTypeId: row.qaTypeId,-->
              <!--                      id: row.id,-->
              <!--                      wkOrderId: row.wkOrderId,-->
              <!--                      isEdit: 'edit',-->
              <!--                      isCompose: row.type == '组合' ? true : false,-->
              <!--                    },-->
              <!--                  })-->
              <!--                "-->
              <!--              >-->
              <!--                编辑-->
              <!--              </el-button>-->
              <!--              <el-button type="text" @click.native="del(row)">删除</el-button>-->
            </span>
            <span v-else>
              <el-button type="text" @click="look(row.id, row.wkOrderId)"
                >查看</el-button
              >
            </span>
          </template>
        </el-table-column>
      </template>
    </m-table-list>
    <!-- <m-log :targetId="targetId" :showVisible="logDisplay" @close="logDisplay = false"></m-log> -->
  </section>
</template>
<script>
import tableList from "components/tableList";
import api from "plus/api";
import {
  statusEnum,
  statusOptions,
  priorityEnum,
  handleResultEnum,
  handleResultOptions,
} from "@/components/data.js";

export default {
  name: "work.mySubmit.list",
  data() {
    return {
      timeQuantum: [],
      workTypeFlag: true,
      workTypeList: [],
      workCutList: [],
      parentTypeId: "",
      filters: {
        parentQaTypeId: "",
        qaTypeId: null,
        created: null,
        beginDate: null,
        endDate: null,
        pageNo: 1,
        pageSize: 10,
        wkOrderId: null,
        workOrderStatus: null,
        priority: "",
        companyInfo: "",
        keyword: "",
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          let endDateVal = this.filters.createEndTime;
          if (endDateVal)
            return time.getTime() > new Date(endDateVal).getTime();
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.filters.createStartTime;
          if (beginDateVal)
            return time.getTime() < new Date(beginDateVal).getTime();
        },
      },
      statusOptions,
      priorityEnum,
      statusEnum,
      handleResultEnum,
      handleResultOptions,
    };
  },
  activated() {
    this.getDropDownList();
  },
  deactivated() {},
  components: {
    "m-table-list": tableList,
  },
  computed: {},
  created() {},
  methods: {
    fetchListFunc: api.work.getMySubmitWork,
    handleTimeChange(val) {
      if (val) {
        const startTime = val[0];
        const endTime = val[1] + 60 * 60 * 1000 * 24 - 1;
        this.filters.beginDate = new Date(startTime);
        this.filters.endDate = new Date(endTime);
      } else {
        this.filters.beginDate = "";
        this.filters.endDate = "";
        this.timeQuantum = [];
      }
    },
    formatPriority(row) {
      return this.priorityEnum[row.priority];
    },
    // 删除
    del(val) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        confirmButtonClass: "confirmBtn",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          api.work.delById({ id: val.id }).then((res) => {
            this.$refs.tableList.getMainData();
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //分类改变引起类型改变
    workCutChange(e) {
      this.filters.qaTypeId = "";
      let filters = {
        id: e,
      };
      api.dropDownList.getWorkType(filters).then((res) => {
        this.workTypeList = res.data.data;
        this.workTypeFlag = false;
        // ;
      });
    },
    getDropDownList() {
      // api.getDropDownList.getWorkType
      api.dropDownList.getWorkCut().then((res) => {
        //工单分类下拉
        // ;
        this.workCutList = res.data.data;
      });
    },
    look(id, wkOrderId) {
      this.$router.push({
        name: "work.mySubmit.detail",
        query: { id, wkOrderId },
      });
    },
    handleSearch() {
      this.$refs.tableList.handleSearch();
    },
    handleClearSearchForm() {
      this.parentTypeId = "";
      this.workTypeFlag = true;
      this.$refs.tableList.resetSearchForm();
      this.timeQuantum = [];
    },
  },
};
</script>
<style lang="less" scoped>
.wap {
  .page {
    color: red;
  }
}
</style>
